import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { useOBMutation } from './useOBMutation';
import { HourSlot } from '@utils/interfaces';

interface ReservationRefreshParams {
  practiceId: string;
  reservationId: string;
}

const useReservationRefresh = ({
  practiceId,
  reservationId,
}: ReservationRefreshParams) => {
  const url = useApiUrl(
    OBRoutes.ReservationRefresh,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )
    ?.replace('##practiceId', practiceId)
    .replace('##reservationId', reservationId);

  return useOBMutation<any, HourSlot>(url || '', {
    method: 'PUT',
  });
};

export default useReservationRefresh;
